import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LinkedInIcon from "./LinkedInIcon";

import "./Footer.css";

const LINKEDIN_URL = "https://www.linkedin.com/in/milanaussatsova/";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            Lutsero
          </Link>
          <p className="footer-tagline">{t("footer.tagline")}</p>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-linkedin"
            aria-label="LinkedIn"
          >
            <LinkedInIcon />
          </a>
        </div>

        <nav className="footer-nav" aria-label="Footer navigation">
          <span className="footer-nav-heading">{t("footer.quickLinks")}</span>
          <NavLink to="/" end>{t("nav.home")}</NavLink>
          <NavLink to="/blog">{t("nav.blog")}</NavLink>
          <NavLink to="/contact">{t("nav.contact")}</NavLink>
        </nav>
      </div>

      <div className="footer-bottom">
        <span>© {year} Lutsero OÜ. {t("footer.rights")}</span>
      </div>
    </footer>
  );
};

export default Footer;
